<template>
<div>
    <b-table striped hover :fields="fields" :items="recipients" >
      <template #cell(previewLink)="data">
        <a :href="axios.defaults.baseURL + 'email/campaigns/preview_person/'+ campaign_id +'/' + data.item.id" target="_blank">Pré-visualizar</a>
      </template>
    </b-table>
</div>
</template>

<script>
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'FamiliesGrid',
  props: ['recipients'],
  data() {
    return {
      campaign_id: null,
      fields: [{
        key: 'compound_key',
        label: 'ID Pessoa'
      }, {
        key: 'surname',
        label: 'Apelido'
      }, {
        key: 'name',
        label: 'Apelido'
      }, {
        key: 'previewLink',
        label: 'Pré-visualizar'
      }]
    }
  },
  watch: {
  },
  methods: {
  },
  created() {
     this.campaign_id = this.$route.params.id;

  }
}
</script>
